import React from 'react';
import landadocLogo from '../assets/Landadoc_logo.png';
import pmsLogo from '../assets/pms_Logo.png';

export default function About() {
  return (
    <div className="container section">
      <div style={{ textAlign: 'center', marginBottom: '60px' }}>
        <h1>Notre Mission</h1>
        <p style={{ maxWidth: '900px', margin: '20px auto' }}>
          Chez <span style={{ color: '#FF6B6B' }}><strong>LandaGroup</strong></span>, nous rendons le numérique <strong>simple, accessible et utile</strong> pour tous. Nous réunissons des expertises complémentaires
          pour créer des solutions fiables, intuitives et adaptées aux besoins réels de nos clients.
        </p>

        <p style={{ maxWidth: '800px', margin: '20px auto' }}> 
          Notre engagement : <strong>Simplifier, Accompagner, Innover</strong> - toujours avec le souci d'apporter une valeur concrète. 
        </p>
      </div>

      <h1 style={{ textAlign: 'center', marginBottom: '40px' }}>Nos Produits</h1>

      <div className="grid-container">
        
        {/* --- Produit 1 - Landadoc --- */}
        <div className="card product-card">
          <div className="card-header-logo">
            <img src={landadocLogo} alt="Logo Landadoc" />
          </div>

          <h3><span className="landadoc">Landadoc</span></h3>
          
          <p className="card-description">
            <span style={{ color: '#FF6B6B' }}> Révolutionnez votre expérience de santé numérique. </span>
            Plateforme qui connecte patients et professionnels de santé, simplifiant la gestion des rendez-vous et le suivi médical.
          </p>
          
          <div className="card-footer">
            <a href="http://www.landadoc.fr" target="_blank" rel="noopener noreferrer" className="btn btn-outline full-width-mobile">
              Visiter le site
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{marginLeft: '8px', verticalAlign: 'middle'}}>
                <path d="M14 3h7v7" />
                <path d="M10 14L21 3" />
                <path d="M21 21H3V3" />
              </svg>
            </a>
          </div>
        </div>

        {/* --- Produit 2 - LandaCare PMS --- */}
        <div className="card product-card">
          <div className="card-header-logo">
             <img src={pmsLogo} alt="Logo LandaCare PMS" />
          </div>

          <h3><span className="landacare">LandaCare PMS</span></h3>
          
          <p className="card-description">
            <span style={{ color: '#1c7ed6' }}>Patient Management System (PMS)</span> — Une solution de gestion complète et adaptable pour les établissements de santé.
          </p>
          
          <div className="card-footer">
            <a href="/contact" className="btn btn-outline full-width-mobile">
              Nous contacter
            </a>
          </div>
        </div>

      </div>

      {/* --- Section Innovation --- */}
      <div style={{ 
        textAlign: 'center', 
        marginTop: '60px',
        padding: '40px 20px',
        background: 'linear-gradient(to bottom, transparent, rgba(255, 107, 107, 0.03))', 
        borderRadius: 'var(--radius)',
        borderTop: '1px solid var(--glass-border)'
      }}>
        <span style={{ 
          display: 'inline-block',
          padding: '8px 20px',
          borderRadius: '30px',
          backgroundColor: 'rgba(6, 214, 160, 0.15)',
          color: 'var(--accent)', 
          fontSize: '0.9rem',
          fontWeight: '700',
          marginBottom: '15px',
          letterSpacing: '1px',
          textTransform: 'uppercase',
          boxShadow: '0 2px 10px rgba(6, 214, 160, 0.1)'
        }}>
          R&D EN COURS
        </span>

        <h3 style={{ marginBottom: '10px', fontSize: '1.2rem' }}>
          L'écosystème <span className="future-text-animated" style={{fontWeight: '700'}}>LandaGroup</span> s'agrandit
        </h3>

        <p style={{ fontSize: '1rem', color: 'var(--text-grey)', maxWidth: '600px', margin: '0 auto' }}>
          Ne manquez pas nos prochaines avancées. Rejoignez-nous dans cette transformation numérique et découvrez bientôt nos futurs produits.
        </p>
      </div>
    </div>
  );
}